/* 验证车牌号 */
export function validateCarPlateNo(rule, value, callback) {
  // reg普通汽车7位  xreg新能源汽车8位
  const reg =
    /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/
  const xreg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{6}/
    // /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/

  if (value.length === 8) {
    if (xreg.test(value)) {
      callback()
    }
  } else if (value.length === 7) {
    if (reg.test(value)) {
      callback()
    }
  }
  return callback(new Error('请输入正确的车牌号'))
}

/* 验证车辆VIN码 */
export function validateCarVin(rule, value, callback) {
  const reg = /^[A-HJ-NPR-Z\d]{17}$/
  if (reg.test(value)) {
    callback()
  } else {
    return callback(new Error('请输入正确的车辆VIN码'))
  }
}

/* 验证车辆发动机号 */
export function validateCarEngineNo(rule, value, callback) {
  const reg = /^[\w\d]{6,17}$/
  if (reg.test(value)) {
    callback()
  } else {
    return callback(new Error('请输入正确的车辆发动机号'))
  }
}

/* 验证汉字 有非空校验 */
export function getValueName(rule, value, callback) {
  if (!value) {
    return callback(new Error('内容不能为空'))
  }
  if (/^[\u4E00-\u9FA5]+$/gi.test(value)) {
    callback()
  } else {
    return callback(new Error('请输入正确的名字'))
  }
}

/* 验证名字（支持少数名字）无非空校验 */
export function getValueName2(rule, value, callback) {
  // eslint-disable-next-line no-useless-escape
  if (/^[\u4E00-\u9FA5\·\.\-]+$/gi.test(value)) {
    callback()
  } else {
    return callback(new Error('请输入正确的名字'))
  }
}

/* 验证身份证 有非空校验 */
export function getIdentity(rule, value, callback) {
  if (value !== '') {
    const _IDRe18 = /^(\d{18}|\d{17}x)$/
    const _IDre15 = /[A-Z0-9]{18}/g
    // 校验身份证：
    if (_IDRe18.test(value) || _IDre15.test(value)) {
      callback()
    } else {
      callback(new Error('格式不正确'))
    }
  }
  callback()
}
/* 验证字母，数字，连字符 */
export function validateEng_Num(rule, value, callback) {
  if (!rule.required || rule.required !== true) {
    if (value === '' || value === null) {
      callback()
      return
    }
  }
  if (value !== '') {
    // eslint-disable-next-line no-useless-escape
    const _IDre15 = /[A-Za-z0-9\-]{15}/g
    // eslint-disable-next-line no-useless-escape
    const _IDre18 = /[A-Za-z0-9\-]{18}/g
    // 校验身份证：
    if (_IDre15.test(value) || _IDre18.test(value)) {
      callback()
    } else {
      callback(new Error('格式不正确'))
    }
  }
  callback()
}

// 验证密码符合规则
export function validatePassWord(rule, value, callback) {
  if (!rule.required || rule.required !== true) {
    if (value === '') {
      callback()
      return
    }
  }
  if (value !== '') {
    const reg = /^[0-9a-zA-Z]{6,18}$/
    if (!reg.test(value)) {
      callback(new Error('密码只能是6-18位的数字或字母'))
    } else {
      callback()
    }
  }
}

// 验证账号符合规则
export function validateAccountNumber(rule, value, callback) {
  if (!rule.required || rule.required !== true) {
    if (value === '') {
      callback()
      return
    }
  }
  if (value !== '') {
    const reg = /^[0-9a-zA-Z]+$/
    if (!reg.test(value)) {
      callback(new Error('账号只能是英文或数字'))
    } else {
      callback()
    }
  }
}


// 姓名验证规则(长度校验2~64，任意字符)
export function validateAccountCustomerName(rule, value, callback) {
  if (!rule.required || rule.required !== true) {
    if (value === '') {
      callback()
      return
    }
  }
  if (value !== '' && value) {
    if (value.indexOf(' ') > -1) {
      callback(new Error('不能输入空格'))
    } else {
      const reg = /[\s\S]{2,64}/
      if (!reg.test(value)) {
        callback(new Error('长度范围2~64'))
      } else {
        callback()
      }
    }
  }
  callback()
}

// 校验 yyyy-mm-dd格式
export function isDate(val) {
  if (val === '长期') return true
  // eslint-disable-next-line no-useless-escape
  const reg = new RegExp(/^\d{4}\-\d{2}\-\d{2}$/)
  return reg.test(val)
}

/**
 * 解析校验提示信息
 * @param {*} ruleObj
 * @returns
 */
export function validateTipMsg(ruleObj) {
  const result = []
  for (const item in ruleObj) {
    const [rule] = ruleObj[item]
    result.push(rule.message)
  }
  return result
}
